module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "alt": "Page 4",
      "src": "images/graphics_4.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.000000, 0.0000, 0.0000, 1.000000, 0,0)",
      "width": "738px"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 346.5191)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "21px"
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "16px",
      "width": "41px"
    }
  }, [_vm._v("copyright")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s23ls",
    staticStyle: {
      "position": "absolute",
      "left": "49px",
      "width": "12px"
    }
  }, [_vm._v("©")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "58px",
      "width": "24px"
    }
  }, [_vm._v("2004")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s23ls",
    staticStyle: {
      "position": "absolute",
      "left": "80px",
      "width": "14px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s25ls",
    staticStyle: {
      "position": "absolute",
      "left": "90px",
      "width": "28px"
    }
  }, [_vm._v("Latifa")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "111px",
      "width": "25px"
    }
  }, [_vm._v("Berry")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "131px",
      "width": "28px"
    }
  }, [_vm._v("Kropf ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 356.1675)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s27ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "33px"
    }
  }, [_vm._v("Photos")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s22ls",
    staticStyle: {
      "position": "absolute",
      "left": "26px",
      "width": "41px"
    }
  }, [_vm._v("copyright")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s23ls",
    staticStyle: {
      "position": "absolute",
      "left": "59px",
      "width": "12px"
    }
  }, [_vm._v("©")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "68px",
      "width": "24px"
    }
  }, [_vm._v("2004")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s23ls",
    staticStyle: {
      "position": "absolute",
      "left": "89px",
      "width": "14px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s25ls",
    staticStyle: {
      "position": "absolute",
      "left": "99px",
      "width": "19px"
    }
  }, [_vm._v("Tod")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "114px",
      "width": "31px"
    }
  }, [_vm._v("Cohen")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 375.4649)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s28ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "14px"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s28ls",
    staticStyle: {
      "position": "absolute",
      "left": "10px",
      "width": "26px"
    }
  }, [_vm._v("rights")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s29ls",
    staticStyle: {
      "position": "absolute",
      "left": "32px",
      "width": "42px"
    }
  }, [_vm._v("reserved.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s30ls",
    staticStyle: {
      "position": "absolute",
      "left": "70px",
      "width": "59px"
    }
  }, [_vm._v("International")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s27ls",
    staticStyle: {
      "position": "absolute",
      "left": "118px",
      "width": "42px"
    }
  }, [_vm._v("copyright")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "153px",
      "width": "39px"
    }
  }, [_vm._v("secured.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "186px",
      "width": "16px"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s32ls",
    staticStyle: {
      "position": "absolute",
      "left": "198px",
      "width": "22px"
    }
  }, [_vm._v("part")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "214px",
      "width": "13px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "224px",
      "width": "19px"
    }
  }, [_vm._v("this")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "239px",
      "width": "26px"
    }
  }, [_vm._v("book")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "259px",
      "width": "21px"
    }
  }, [_vm._v("may")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "276px",
      "width": "15px"
    }
  }, [_vm._v("be")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s34ls",
    staticStyle: {
      "position": "absolute",
      "left": "287px",
      "width": "55px"
    }
  }, [_vm._v("reproduced,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "332px",
      "width": "31px"
    }
  }, [_vm._v("stored")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "357px",
      "width": "12px"
    }
  }, [_vm._v("in")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 385.1133)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "10px"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s29ls",
    staticStyle: {
      "position": "absolute",
      "left": "6px",
      "width": "38px"
    }
  }, [_vm._v("retrieval")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s35ls",
    staticStyle: {
      "position": "absolute",
      "left": "38px",
      "width": "35px"
    }
  }, [_vm._v("system,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "67px",
      "width": "13px"
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s34ls",
    staticStyle: {
      "position": "absolute",
      "left": "77px",
      "width": "53px"
    }
  }, [_vm._v("transmitted")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "120px",
      "width": "12px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "129px",
      "width": "20px"
    }
  }, [_vm._v("any")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "144px",
      "width": "23px"
    }
  }, [_vm._v("form")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "163px",
      "width": "13px"
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "172px",
      "width": "14px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "183px",
      "width": "20px"
    }
  }, [_vm._v("any")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s36ls",
    staticStyle: {
      "position": "absolute",
      "left": "198px",
      "width": "80px"
    }
  }, [_vm._v("means—electronic,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s29ls",
    staticStyle: {
      "position": "absolute",
      "left": "267px",
      "width": "53px"
    }
  }, [_vm._v("mechanical,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s30ls",
    staticStyle: {
      "position": "absolute",
      "left": "312px",
      "width": "63px"
    }
  }, [_vm._v("photocopying,")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 394.7598)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s25ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "44px"
    }
  }, [_vm._v("recording,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "37px",
      "width": "13px"
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "47px",
      "width": "85px"
    }
  }, [_vm._v("otherwise-—without")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "118px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s25ls",
    staticStyle: {
      "position": "absolute",
      "left": "132px",
      "width": "23px"
    }
  }, [_vm._v("prior")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s23ls",
    staticStyle: {
      "position": "absolute",
      "left": "150px",
      "width": "34px"
    }
  }, [_vm._v("written")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s25ls",
    staticStyle: {
      "position": "absolute",
      "left": "177px",
      "width": "48px"
    }
  }, [_vm._v("permission")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "219px",
      "width": "13px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "228px",
      "width": "31px"
    }
  }, [_vm._v("Lerner")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "253px",
      "width": "46px"
    }
  }, [_vm._v("Publishing")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "292px",
      "width": "32px"
    }
  }, [_vm._v("Group,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s37ls",
    staticStyle: {
      "position": "absolute",
      "left": "318px",
      "width": "20px"
    }
  }, [_vm._v("Inc.,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s38ls",
    staticStyle: {
      "position": "absolute",
      "left": "336px",
      "width": "33px"
    }
  }, [_vm._v("except")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 404.4082)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "16px"
    }
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "12px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s29ls",
    staticStyle: {
      "position": "absolute",
      "left": "25px",
      "width": "40px"
    }
  }, [_vm._v("inclusion")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "59px",
      "width": "13px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "69px",
      "width": "24px"
    }
  }, [_vm._v("brief")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s39ls",
    staticStyle: {
      "position": "absolute",
      "left": "87px",
      "width": "50px"
    }
  }, [_vm._v("quotations")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "127px",
      "width": "12px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "136px",
      "width": "15px"
    }
  }, [_vm._v("an")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s32ls",
    staticStyle: {
      "position": "absolute",
      "left": "148px",
      "width": "64px"
    }
  }, [_vm._v("acknowledged")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s35ls",
    staticStyle: {
      "position": "absolute",
      "left": "201px",
      "width": "33px"
    }
  }, [_vm._v("review. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 423.7051)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s40ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "42px"
    }
  }, [_vm._v("KAR-BEN")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s25ls",
    staticStyle: {
      "position": "absolute",
      "left": "34px",
      "width": "52px"
    }
  }, [_vm._v("PUBLISHING ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 433.3535)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "10px"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s40ls",
    staticStyle: {
      "position": "absolute",
      "left": "6px",
      "width": "35px"
    }
  }, [_vm._v("division")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "36px",
      "width": "13px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "45px",
      "width": "31px"
    }
  }, [_vm._v("Lerner")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "70px",
      "width": "46px"
    }
  }, [_vm._v("Publishing")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "109px",
      "width": "32px"
    }
  }, [_vm._v("Group,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "136px",
      "width": "18px"
    }
  }, [_vm._v("Inc. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 443.0020)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs ",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "20px"
    }
  }, [_vm._v("241")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s25ls",
    staticStyle: {
      "position": "absolute",
      "left": "17px",
      "width": "22px"
    }
  }, [_vm._v("First")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s38ls",
    staticStyle: {
      "position": "absolute",
      "left": "35px",
      "width": "36px"
    }
  }, [_vm._v("Avenue")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s39ls",
    staticStyle: {
      "position": "absolute",
      "left": "63px",
      "width": "28px"
    }
  }, [_vm._v("North ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 452.6504)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s26ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "57px"
    }
  }, [_vm._v("Minneapolis,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "47px",
      "width": "18px"
    }
  }, [_vm._v("MN")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs ",
    staticStyle: {
      "position": "absolute",
      "left": "62px",
      "width": "30px"
    }
  }, [_vm._v("55401")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s42ls",
    staticStyle: {
      "position": "absolute",
      "left": "89px",
      "width": "26px"
    }
  }, [_vm._v("U.S.A. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 462.2988)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "62px"
    }
  }, [_vm._v("800-4KARBEN ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 481.5957)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s27ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "37px"
    }
  }, [_vm._v("Website")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s21ls",
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "width": "39px"
    }
  }, [_vm._v("address:")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-color": "black",
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://www.karben.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s34ls",
    staticStyle: {
      "position": "absolute",
      "left": "63px",
      "width": "74px"
    }
  }, [_vm._v("www.karben.com ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 500.8906)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s34ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "51px"
    }
  }, [_vm._v("Distributed")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "41px",
      "width": "14px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "51px",
      "width": "27px"
    }
  }, [_vm._v("Open")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "73px",
      "width": "27px"
    }
  }, [_vm._v("Road")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s30ls",
    staticStyle: {
      "position": "absolute",
      "left": "93px",
      "width": "48px"
    }
  }, [_vm._v("Integrated")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s33ls",
    staticStyle: {
      "position": "absolute",
      "left": "132px",
      "width": "32px"
    }
  }, [_vm._v("Media,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "159px",
      "width": "18px"
    }
  }, [_vm._v("Inc. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 510.5391)",
      "-webkit-transform-origin": "0px 7.736393px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s20fs s41ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "23px"
    }
  }, [_vm._v("ISBN")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s43ls",
    staticStyle: {
      "position": "absolute",
      "left": "19px",
      "width": "78px"
    }
  }, [_vm._v("978-1-4976-6481-4")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s20fs s31ls",
    staticStyle: {
      "position": "absolute",
      "left": "95px",
      "width": "39px"
    }
  }, [_vm._v("(ebook) ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 530.9196)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s45ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "28px"
    }
  }, [_vm._v("Library")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "22px",
      "width": "11px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s28ls",
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "width": "38px"
    }
  }, [_vm._v("Congress")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s3ls",
    staticStyle: {
      "position": "absolute",
      "left": "60px",
      "width": "87px"
    }
  }, [_vm._v("Cataloging-in-Publication")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "138px",
      "width": "20px"
    }
  }, [_vm._v("Data ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 550.2146)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s46ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "25px"
    }
  }, [_vm._v("Kropf,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "20px",
      "width": "23px"
    }
  }, [_vm._v("Latifa")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s48ls",
    staticStyle: {
      "position": "absolute",
      "left": "39px",
      "width": "25px"
    }
  }, [_vm._v("Berry. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 559.8591)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "14px",
      "width": "15px"
    }
  }, [_vm._v("It’s")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "25px",
      "width": "29px"
    }
  }, [_vm._v("sukkah")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "49px",
      "width": "20px"
    }
  }, [_vm._v("time")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s36ls",
    staticStyle: {
      "position": "absolute",
      "left": "65px",
      "width": "9px"
    }
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "70px",
      "width": "12px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "79px",
      "width": "23px"
    }
  }, [_vm._v("Latifa")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s49ls",
    staticStyle: {
      "position": "absolute",
      "left": "98px",
      "width": "23px"
    }
  }, [_vm._v("Berry")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s37ls",
    staticStyle: {
      "position": "absolute",
      "left": "116px",
      "width": "23px"
    }
  }, [_vm._v("Kropf")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "135px",
      "width": "7px"
    }
  }, [_vm._v(";")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "139px",
      "width": "46px"
    }
  }, [_vm._v("photographs")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 191.7511, 569.5056)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "12px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s46ls",
    staticStyle: {
      "position": "absolute",
      "left": "8px",
      "width": "17px"
    }
  }, [_vm._v("Tod")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "22px",
      "width": "28px"
    }
  }, [_vm._v("Cohen. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 579.1501)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "21px",
      "width": "11px"
    }
  }, [_vm._v("p.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s50ls",
    staticStyle: {
      "position": "absolute",
      "left": "35px",
      "width": "18px"
    }
  }, [_vm._v("cm. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 588.7946)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s48ls",
    staticStyle: {
      "position": "absolute",
      "left": "14px",
      "width": "40px"
    }
  }, [_vm._v("Summary:")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "47px",
      "width": "46px"
    }
  }, [_vm._v("Photographs")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "87px",
      "width": "22px"
    }
  }, [_vm._v("show")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "105px",
      "width": "17px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "119px",
      "width": "16px"
    }
  }, [_vm._v("text")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s45ls",
    staticStyle: {
      "position": "absolute",
      "left": "132px",
      "width": "38px"
    }
  }, [_vm._v("describes")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "163px",
      "width": "32px"
    }
  }, [_vm._v("children")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 191.7511, 598.4392)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s37ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "32px"
    }
  }, [_vm._v("creating")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "26px",
      "width": "17px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "40px",
      "width": "42px"
    }
  }, [_vm._v("celebrating")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "76px",
      "width": "11px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "83px",
      "width": "9px"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s18ls",
    staticStyle: {
      "position": "absolute",
      "left": "89px",
      "width": "31px"
    }
  }, [_vm._v("sukkah,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "115px",
      "width": "9px"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s45ls",
    staticStyle: {
      "position": "absolute",
      "left": "121px",
      "width": "30px"
    }
  }, [_vm._v("harvest")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "146px",
      "width": "23px"
    }
  }, [_vm._v("booth")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "165px",
      "width": "19px"
    }
  }, [_vm._v("built")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "181px",
      "width": "11px"
    }
  }, [_vm._v("to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 191.7511, 608.0837)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s51ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "36px"
    }
  }, [_vm._v("celebrate")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "width": "15px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "42px",
      "width": "27px"
    }
  }, [_vm._v("Jewish")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "64px",
      "width": "28px"
    }
  }, [_vm._v("holiday")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "88px",
      "width": "11px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s18ls",
    staticStyle: {
      "position": "absolute",
      "left": "96px",
      "width": "30px"
    }
  }, [_vm._v("Sukkot. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 617.7282)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s37ls",
    staticStyle: {
      "position": "absolute",
      "left": "14px",
      "width": "24px"
    }
  }, [_vm._v("ISBN:")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s52ls",
    staticStyle: {
      "position": "absolute",
      "left": "33px",
      "width": "94px"
    }
  }, [_vm._v("978–1–58013–084–4")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "107px",
      "width": "17px"
    }
  }, [_vm._v("(lib.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "120px",
      "width": "19px"
    }
  }, [_vm._v("bdg.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "135px",
      "width": "7px"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "139px",
      "width": "17px"
    }
  }, [_vm._v("alk.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "152px",
      "width": "26px"
    }
  }, [_vm._v("paper) ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 627.3728)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s48ls",
    staticStyle: {
      "position": "absolute",
      "left": "14px",
      "width": "12px"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s18ls",
    staticStyle: {
      "position": "absolute",
      "left": "22px",
      "width": "60px"
    }
  }, [_vm._v("Sukkot—Juvenile")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "75px",
      "width": "37px"
    }
  }, [_vm._v("literature.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s46ls",
    staticStyle: {
      "position": "absolute",
      "left": "108px",
      "width": "14px"
    }
  }, [_vm._v("[1.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s18ls",
    staticStyle: {
      "position": "absolute",
      "left": "118px",
      "width": "30px"
    }
  }, [_vm._v("Sukkot.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s48ls",
    staticStyle: {
      "position": "absolute",
      "left": "146px",
      "width": "12px"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s51ls",
    staticStyle: {
      "position": "absolute",
      "left": "154px",
      "width": "37px"
    }
  }, [_vm._v("Holidays.]")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 191.7511, 637.0173)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "9px"
    }
  }, [_vm._v("I.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "5px",
      "width": "28px"
    }
  }, [_vm._v("Cohen,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s17ls",
    staticStyle: {
      "position": "absolute",
      "left": "28px",
      "width": "19px"
    }
  }, [_vm._v("Tod,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "43px",
      "width": "13px"
    }
  }, [_vm._v("ill.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs ",
    staticStyle: {
      "position": "absolute",
      "left": "54px",
      "width": "11px"
    }
  }, [_vm._v("II.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s47ls",
    staticStyle: {
      "position": "absolute",
      "left": "62px",
      "width": "21px"
    }
  }, [_vm._v("Title. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 191.7511, 646.6618)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s35ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "60px"
    }
  }, [_vm._v("BM695.S8K74")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s44fs s52ls",
    staticStyle: {
      "position": "absolute",
      "left": "50px",
      "width": "25px"
    }
  }, [_vm._v("2002 ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 191.7511, 656.3064)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s50ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "64px"
    }
  }, [_vm._v("296.4’33—dc21")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 191.7511, 656.3064)",
      "-webkit-transform-origin": "0px 6.631181px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s44fs s52ls",
    staticStyle: {
      "position": "absolute",
      "left": "167px",
      "width": "57px"
    }
  }, [_vm._v("2002156662 ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 61.4653)",
      "-webkit-transform-origin": "0px 15.472786px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s53ff s54fs s55ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "55px"
    }
  }, [_vm._v("Thanks")]), _vm._v(" "), _c('span', {
    staticClass: "s53ff s54fs s56ls",
    staticStyle: {
      "position": "absolute",
      "left": "56px",
      "width": "18px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s53ff s54fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "75px",
      "width": "101px"
    }
  }, [_vm._v("Congregation")]), _vm._v(" "), _c('span', {
    staticClass: "s53ff s54fs s4ls",
    staticStyle: {
      "position": "absolute",
      "left": "175px",
      "width": "37px"
    }
  }, [_vm._v("Beth")]), _vm._v(" "), _c('span', {
    staticClass: "s53ff s54fs s56ls",
    staticStyle: {
      "position": "absolute",
      "left": "213px",
      "width": "44px"
    }
  }, [_vm._v("Israel")]), _vm._v(" "), _c('span', {
    staticClass: "s53ff s54fs s57ls",
    staticStyle: {
      "position": "absolute",
      "left": "257px",
      "width": "87px"
    }
  }, [_vm._v("Preschool... ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 87.7326)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "15px"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "13px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s4ls",
    staticStyle: {
      "position": "absolute",
      "left": "31px",
      "width": "24px"
    }
  }, [_vm._v("staff")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "55px",
      "width": "17px"
    }
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "70px",
      "width": "26px"
    }
  }, [_vm._v("their")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "94px",
      "width": "46px"
    }
  }, [_vm._v("flexibility")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "137px",
      "width": "22px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "157px",
      "width": "62px"
    }
  }, [_vm._v("enthusiasm,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "217px",
      "width": "13px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "229px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "246px",
      "width": "40px"
    }
  }, [_vm._v("parents")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "284px",
      "width": "17px"
    }
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "300px",
      "width": "26px"
    }
  }, [_vm._v("their")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 99.7902)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "51px"
    }
  }, [_vm._v("wonderful")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "48px",
      "width": "46px"
    }
  }, [_vm._v("children,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "90px",
      "width": "13px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "102px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s62ls",
    staticStyle: {
      "position": "absolute",
      "left": "120px",
      "width": "42px"
    }
  }, [_vm._v("children")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "160px",
      "width": "23px"
    }
  }, [_vm._v("who")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "182px",
      "width": "28px"
    }
  }, [_vm._v("bring")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "208px",
      "width": "19px"
    }
  }, [_vm._v("me")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "225px",
      "width": "15px"
    }
  }, [_vm._v("so")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "239px",
      "width": "30px"
    }
  }, [_vm._v("much")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "268px",
      "width": "21px"
    }
  }, [_vm._v("joy. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 123.9054)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "15px"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "13px",
      "width": "18px"
    }
  }, [_vm._v("my")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "width": "46px"
    }
  }, [_vm._v("children,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s62ls",
    staticStyle: {
      "position": "absolute",
      "left": "72px",
      "width": "47px"
    }
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "117px",
      "width": "22px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "138px",
      "width": "45px"
    }
  }, [_vm._v("Michael,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "179px",
      "width": "17px"
    }
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "195px",
      "width": "30px"
    }
  }, [_vm._v("being")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "223px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s56ls",
    staticStyle: {
      "position": "absolute",
      "left": "241px",
      "width": "31px"
    }
  }, [_vm._v("sweet")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "271px",
      "width": "49px"
    }
  }, [_vm._v("fragrance")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "317px",
      "width": "13px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "329px",
      "width": "18px"
    }
  }, [_vm._v("my")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "345px",
      "width": "22px"
    }
  }, [_vm._v("life,")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 135.9630)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "22px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "20px",
      "width": "13px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "32px",
      "width": "18px"
    }
  }, [_vm._v("my")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s62ls",
    staticStyle: {
      "position": "absolute",
      "left": "48px",
      "width": "45px"
    }
  }, [_vm._v("husband")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "91px",
      "width": "32px"
    }
  }, [_vm._v("Peter,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "121px",
      "width": "18px"
    }
  }, [_vm._v("my")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "138px",
      "width": "37px"
    }
  }, [_vm._v("Sukkat")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "173px",
      "width": "43px"
    }
  }, [_vm._v("Shalom. ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 148.0207)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s57ls",
    staticStyle: {
      "position": "absolute",
      "left": "298px",
      "width": "32px"
    }
  }, [_vm._v("L.B.K. ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 184.1935)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "31px"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s63ls",
    staticStyle: {
      "position": "absolute",
      "left": "29px",
      "width": "40px"
    }
  }, [_vm._v("Sukkot: ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 196.2511)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "37px"
    }
  }, [_vm._v("Sukkot")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "34px",
      "width": "12px"
    }
  }, [_vm._v("is")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "45px",
      "width": "10px"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "54px",
      "width": "19px"
    }
  }, [_vm._v("fall")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "71px",
      "width": "38px"
    }
  }, [_vm._v("holiday")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "106px",
      "width": "22px"
    }
  }, [_vm._v("that")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "127px",
      "width": "54px"
    }
  }, [_vm._v("celebrates")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "178px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s63ls",
    staticStyle: {
      "position": "absolute",
      "left": "196px",
      "width": "39px"
    }
  }, [_vm._v("harvest")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "233px",
      "width": "22px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "254px",
      "width": "36px"
    }
  }, [_vm._v("recalls")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "287px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "304px",
      "width": "35px"
    }
  }, [_vm._v("Jewish")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 208.3087)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "45px"
    }
  }, [_vm._v("people’s")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "41px",
      "width": "53px"
    }
  }, [_vm._v("wandering")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "92px",
      "width": "13px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "103px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "121px",
      "width": "34px"
    }
  }, [_vm._v("desert")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "153px",
      "width": "26px"
    }
  }, [_vm._v("after")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "178px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "195px",
      "width": "41px"
    }
  }, [_vm._v("Exodus.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "237px",
      "width": "21px"
    }
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "257px",
      "width": "39px"
    }
  }, [_vm._v("sukkah")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "293px",
      "width": "38px"
    }
  }, [_vm._v("(plural,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "328px",
      "width": "42px"
    }
  }, [_vm._v("sukkot),")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 220.3664)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "10px"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s62ls",
    staticStyle: {
      "position": "absolute",
      "left": "8px",
      "width": "52px"
    }
  }, [_vm._v("temporary")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "58px",
      "width": "46px"
    }
  }, [_vm._v("dwelling,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "101px",
      "width": "12px"
    }
  }, [_vm._v("is")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "111px",
      "width": "25px"
    }
  }, [_vm._v("akin")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "134px",
      "width": "13px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "146px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "164px",
      "width": "24px"
    }
  }, [_vm._v("huts")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "187px",
      "width": "41px"
    }
  }, [_vm._v("farmers")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "225px",
      "width": "27px"
    }
  }, [_vm._v("lived")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "250px",
      "width": "13px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "261px",
      "width": "34px"
    }
  }, [_vm._v("during")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 232.4240)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "17px",
      "width": "42px"
    }
  }, [_vm._v("harvest,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "57px",
      "width": "15px"
    }
  }, [_vm._v("as")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "71px",
      "width": "23px"
    }
  }, [_vm._v("well")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "92px",
      "width": "15px"
    }
  }, [_vm._v("as")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "105px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "123px",
      "width": "42px"
    }
  }, [_vm._v("shelters")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "163px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "181px",
      "width": "35px"
    }
  }, [_vm._v("Jewish")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "214px",
      "width": "46px"
    }
  }, [_vm._v("travelers")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "257px",
      "width": "25px"
    }
  }, [_vm._v("built")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "280px",
      "width": "13px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "291px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s63ls",
    staticStyle: {
      "position": "absolute",
      "left": "309px",
      "width": "37px"
    }
  }, [_vm._v("desert.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "347px",
      "width": "21px"
    }
  }, [_vm._v("The")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 244.4816)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "23px"
    }
  }, [_vm._v("roof")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "21px",
      "width": "13px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "32px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "50px",
      "width": "39px"
    }
  }, [_vm._v("sukkah")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "87px",
      "width": "12px"
    }
  }, [_vm._v("is")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "97px",
      "width": "42px"
    }
  }, [_vm._v("covered")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "136px",
      "width": "23px"
    }
  }, [_vm._v("with")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "158px",
      "width": "48px"
    }
  }, [_vm._v("branches")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "204px",
      "width": "22px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s57ls",
    staticStyle: {
      "position": "absolute",
      "left": "224px",
      "width": "15px"
    }
  }, [_vm._v("its")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "238px",
      "width": "28px"
    }
  }, [_vm._v("walls")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "264px",
      "width": "20px"
    }
  }, [_vm._v("are")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "282px",
      "width": "51px"
    }
  }, [_vm._v("decorated")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "331px",
      "width": "23px"
    }
  }, [_vm._v("with")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 256.5392)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "40px"
    }
  }, [_vm._v("colorful")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "36px",
      "width": "28px"
    }
  }, [_vm._v("fruits")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "63px",
      "width": "22px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "83px",
      "width": "55px"
    }
  }, [_vm._v("vegetables")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "136px",
      "width": "13px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "148px",
      "width": "72px"
    }
  }, [_vm._v("commemorate")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "218px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "236px",
      "width": "42px"
    }
  }, [_vm._v("harvest.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s62ls",
    staticStyle: {
      "position": "absolute",
      "left": "278px",
      "width": "44px"
    }
  }, [_vm._v("Families")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "319px",
      "width": "22px"
    }
  }, [_vm._v("eat,")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "340px",
      "width": "32px"
    }
  }, [_vm._v("study,")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 268.5968)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "22px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "20px",
      "width": "56px"
    }
  }, [_vm._v("sometimes")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "73px",
      "width": "30px"
    }
  }, [_vm._v("sleep")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "101px",
      "width": "13px"
    }
  }, [_vm._v("in")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "112px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "130px",
      "width": "42px"
    }
  }, [_vm._v("sukkah.")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "172px",
      "width": "19px"
    }
  }, [_vm._v("We")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "190px",
      "width": "29px"
    }
  }, [_vm._v("bless")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "217px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "235px",
      "width": "28px"
    }
  }, [_vm._v("etrog")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "261px",
      "width": "13px"
    }
  }, [_vm._v("(a")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "273px",
      "width": "30px"
    }
  }, [_vm._v("citrus")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "301px",
      "width": "26px"
    }
  }, [_vm._v("fruit)")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "326px",
      "width": "22px"
    }
  }, [_vm._v("and")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 280.6545)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "33px"
    }
  }, [_vm._v("shake")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "48px",
      "width": "48px"
    }
  }, [_vm._v("branches")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "94px",
      "width": "13px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "105px",
      "width": "19px"
    }
  }, [_vm._v("the")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "123px",
      "width": "27px"
    }
  }, [_vm._v("lulav")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "148px",
      "width": "13px"
    }
  }, [_vm._v("(a")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "160px",
      "width": "28px"
    }
  }, [_vm._v("palm")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "186px",
      "width": "29px"
    }
  }, [_vm._v("frond")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "213px",
      "width": "34px"
    }
  }, [_vm._v("bound")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "245px",
      "width": "23px"
    }
  }, [_vm._v("with")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s61ls",
    staticStyle: {
      "position": "absolute",
      "left": "267px",
      "width": "48px"
    }
  }, [_vm._v("branches")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "312px",
      "width": "13px"
    }
  }, [_vm._v("of")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "324px",
      "width": "34px"
    }
  }, [_vm._v("myrtle")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0000, 184.5157, 292.7121)",
      "-webkit-transform-origin": "0px 9.946725px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "22px"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s63ls",
    staticStyle: {
      "position": "absolute",
      "left": "20px",
      "width": "36px"
    }
  }, [_vm._v("willow)")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "54px",
      "width": "13px"
    }
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s24ls",
    staticStyle: {
      "position": "absolute",
      "left": "66px",
      "width": "31px"
    }
  }, [_vm._v("thank")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "95px",
      "width": "23px"
    }
  }, [_vm._v("God")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s59ls",
    staticStyle: {
      "position": "absolute",
      "left": "116px",
      "width": "17px"
    }
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s60ls",
    staticStyle: {
      "position": "absolute",
      "left": "132px",
      "width": "16px"
    }
  }, [_vm._v("all")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "145px",
      "width": "32px"
    }
  }, [_vm._v("things")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s19ls",
    staticStyle: {
      "position": "absolute",
      "left": "176px",
      "width": "22px"
    }
  }, [_vm._v("that")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s58fs s56ls",
    staticStyle: {
      "position": "absolute",
      "left": "198px",
      "width": "29px"
    }
  }, [_vm._v("grow. ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e691844","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pg_4.vue
// module id = 63
// module chunks = 0